import React from 'react';

import history from '../../../services/history';
import { ButtonLink, EmptyContentText } from './styles';

const EmptyRelatorios = () => {
  return (
    <EmptyContentText>
      Nenhum relatório gerado
      <span>
        Para gerar, clique no botão{' '}
        <ButtonLink
          type="button"
          onClick={() => {
            history.push('/novo/relatorio-beneficiario');
          }}
          data-testid="link-add-contratante"
        >
          + Novo Relatório
        </ButtonLink>
      </span>
    </EmptyContentText>
  );
};

export default EmptyRelatorios;
